import { IPagination } from "../data/AppInterface";

type TQueryValue = string | number | null | undefined;

export const toQueryString = (params: Record<string, TQueryValue>): string => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined && String(value) !== "") {
      query.append(key, String(value));
    }
  });
  const text = query.toString();
  return text ? `?${text}` : "";
};

export const paginationParams = (pagination: IPagination) => ({
  perPageRows: pagination.perPageRows,
  currentPage: pagination.currentPage,
  sortBy: pagination.sortBy,
  orderBy: pagination.orderBy,
});
